import DashboardRepository from "../../../domain/repositories/dashboard/DashboardRepository";
import SearchResponse from "../../../domain/models/dashboard/SearchResponse";
import ProductItem from "../../../domain/models/dashboard/ProductItem";
import RequestOptions from "../../../util/api/RequestOptions";
import AuthRepository from "../../../domain/repositories/auth/AuthRepository";
import ApiHelper from "../../../util/api/ApiHelper";
import { APPLICATION_SERVER } from "../../../constants";
import BestSellerItem from "../../../domain/models/dashboard/BestSellerItem";

export default class DashboardRepositoryImpl implements DashboardRepository {
  private authRepository: AuthRepository;

  public constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  public searchProducts = (countryCode: string, searchQuery: string): Promise<SearchResponse | ProductItem[]> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);

    return ApiHelper.fetchGetJson<SearchResponse | ProductItem[]>(
      `${APPLICATION_SERVER}/api/scraper/search/${countryCode}/${searchQuery}`,
      requestOptions
    );
  };

  public searchGenerated = (countryCode: string, searchQuery: string): Promise<SearchResponse | ProductItem[]> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);

    return ApiHelper.fetchGetJson<SearchResponse | ProductItem[]>(
      `${APPLICATION_SERVER}/api/scraper/generate/${countryCode}/${searchQuery}`,
      requestOptions
    );
  };

  public searchRandomProducts = (countryCode: string): Promise<SearchResponse | ProductItem[]> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);

    return ApiHelper.fetchGetJson<SearchResponse | ProductItem[]>(
      `${APPLICATION_SERVER}/api/scraper/random_niche/${countryCode}`,
      requestOptions
    );
  };

  public pingProducts = (queryCodeId: string): Promise<ProductItem[]> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);

    return ApiHelper.fetchGetJson<ProductItem[]>(
      `${APPLICATION_SERVER}/api/scraper/ping/${queryCodeId}`,
      requestOptions
    );
  };

  public getBestSellers = (): Promise<BestSellerItem[]> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);

    return ApiHelper.fetchGetJson<BestSellerItem[]>(`${APPLICATION_SERVER}/api/best_sellers`, requestOptions);
  };
}
